export default {
    "study_guide.title": "Guide d'étude Officiel",
    "study_guide.subtitle": "Préparez-vous efficacement avec tout le contenu nécessaire pour réussir votre examen.",
    "study_guide.train_now": "S'entraîner",
    "study_guide.back_home": "Retour à l'accueil",
    "study_guide.learn_title": "Ce que vous allez apprendre",

    "study_guide.chapters": [
        "Valeurs et symboles canadiens",
        "Histoire et géographie du Canada",
        "Système politique et gouvernemental",
        "Droits et responsabilités des citoyens",
        "Le système judiciaire canadien",
        "Les régions du Canada et leurs particularités"
    ],

    "study_guide.cta.title": "Prêt pour le grand jour ?",
    "study_guide.cta.desc": "Rejoignez CitoyenPro aujourd'hui et maîtrisez tout le contenu du guide officiel grâce à nos quiz adaptatifs.",
    "study_guide.cta.button": "Commencer gratuitement",

    "study_guide.footer.copyright": "© 2025 CitoyenPro. Tous droits réservés.",
    "study_guide.footer.privacy": "Confidentialité",
    "study_guide.footer.terms": "Conditions"
};
